module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_yogiyo_m.25e712049580aba9d7432efb50c075a2.png";